import NumberInputV1 from "../../../../components/form_builder/elements/number_input/NumberInputV1.vue";
import {
  validateRequired,
  validateNumberGreaterEqualThan,
  validateNumberLessEqualThan
} from "../../../../helpers/validation";

export default {
  componentName: "fb-number-input-v1",
  component: NumberInputV1,
  defaultAttrs: {
    properties: {
      label: "Label",
      placeholder: "Write something...",
      description: "",
      value: "",
      required: false,
      hidden: false,
      readonly: false,
      minValue: null,
      maxValue: null,
      style: {},
      eFormEditable: true,
      dependentProperties: {}
    }
  },
  gridAttrs: {
    type: "template",
    width: 100,
    template: ({ value }) => value
  },
  getValueReport: value => {
    return value;
  },
  validate: ({ value, properties }) => {
    const errors = [];
    if (properties.required && !validateRequired(value))
      errors.push("This field is required");
    if (
      validateRequired(value) &&
      typeof properties.minValue != "undefined" &&
      !validateNumberGreaterEqualThan(value, properties.minValue)
    )
      errors.push("This value must be greater than or equal to " + properties.minValue);
    if (
      validateRequired(value) &&
      typeof properties.maxValue != "undefined" &&
      !validateNumberLessEqualThan(value, properties.maxValue)
    )
      errors.push("This value must be less than or equal to " + properties.maxValue);
    return errors;
  }
};
